// extracted by mini-css-extract-plugin
module.exports = {"OurEmployees":"OurEmployees-module__OurEmployees___2ngKk","content":"OurEmployees-module__content___RoOTy","text":"OurEmployees-module__text___f3V0-"};